// Big Head Library Props
// Reference: https://github.com/RobertBroersma/bigheads#accessory
// NOTE: Few colors do not have a default name, so used their rgb code instead.
import accessoryIcon from './icons/accessoryIcon.png';
import bodyIcon from './icons/bodyIcon.png';
import eyeIcon from './icons/eyeIcon.png';
import clothingIcon from './icons/clothesIcon.png';
import hairIcon from './icons/hairIcon.png';
import eyebrowIcon from './icons/eyebrowIcon.png';
import faceMaskIcon from './icons/faceMaskIcon.png';
import mouthIcon from './icons/mouthIcon.png';
import facialHairIcon from './icons/facialHairIcon.png';
import graphicIcon from './icons/graphicIcon.png';
import hatIcon from './icons/hatIcon.png';
import lashesIcon from './icons/lashesIcon.png';

export const attributes = {
    options: [
        { name: 'accessory', icon: accessoryIcon, id: 0, colorOptions: -1 }, // 0
        { name: 'body', icon: bodyIcon, id: 1, colorOptions: 4 }, // 1
        { name: 'clothing', icon: clothingIcon, id: 2, colorOptions: 0 }, // 2
        { name: 'eyebrows', icon: eyebrowIcon, id: 3, colorOptions: -1 }, // 3
        { name: 'eyes', icon: eyeIcon, id: 4, colorOptions: -1 }, // 4
        { name: 'faceMask', icon: faceMaskIcon, id: 5, colorOptions: 1 }, // 5
        { name: 'facialHair', icon: facialHairIcon, id: 6, colorOptions: -1 }, // 6
        { name: 'graphic', icon: graphicIcon, id: 7, colorOptions: -1 }, // 7
        { name: 'hair', icon: hairIcon, id: 8, colorOptions: 3 }, // 8
        { name: 'hat', icon: hatIcon, id: 9, colorOptions: 2 }, // 9
        { name: 'lashes', icon: lashesIcon, id: 10, colorOptions: -1 }, // 10
        { name: 'mouth', icon: mouthIcon, id: 11, colorOptions: -1 }, // 11
    ],
    colors: [
        { name: 'clothingColor', id: 0 },
        { name: 'faceMaskColor', id: 1 },
        { name: 'hatColor', id: 2 },
        { name: 'hairColor', id: 3 },
        { name: 'skinTone', id: 4 },
        { name: 'backgroundColor', id: 5 },
    ],
};

export const selectedToStyle = {
    0: 'accessory',
    1: 'body',
    2: 'clothing',
    3: 'eyebrows',
    4: 'eyes',
    5: 'faceMask',
    6: 'facialHair',
    7: 'graphic',
    8: 'hair',
    9: 'hat',
    10: 'lashes',
    11: 'mouth',
};

export const styles = [
    ['none', 'roundGlasses', 'tinyGlasses', 'shades'], // accessory
    ['chest', 'breasts'], // body
    ['naked', 'shirt', 'dressShirt', 'vneck', 'tankTop', 'dress'], // clothing
    ['raised', 'leftLowered', 'serious', 'angry', 'concerned'], // eyebrows
    ['normal', 'leftTwitch', 'happy', 'content', 'squint', 'simple', 'dizzy', 'wink', 'heart'], // eyes
    [true, false], // faceMask
    ['none', 'stubble', 'mediumBeard'], // facialHair
    ['none', 'redwood', 'gatsby', 'vue', 'react', 'graphQL'], // graphic
    ['none', 'long', 'bun', 'short', 'pixie', 'balding', 'buzz', 'afro', 'bob'], // hair
    ['none', 'beanie', 'turban'], // hat
    [true, false], // lashes
    ['grin', 'sad', 'openSmile', 'lips', 'open', 'serious', 'tongue'], // mouth
];

export const colorSelectedToStyle = {
    0: 'clothingColor',
    1: 'faceMaskColor',
    2: 'hatColor',
    3: 'hairColor',
    4: 'skinTone',
    5: 'avatarBackgroundColor',
};

export const colorStyles = [
    ['white', 'blue', 'black', 'green', 'red'], // clothing color
    ['white', 'blue', 'black', 'green', 'red'], // faceMask Color
    ['white', 'blue', 'black', 'green', 'red'], // HatColor
    ['#F0E68C', 'orange', 'black', 'white', 'brown', 'blue', 'pink'], // hairColor
    ['#fff2e6', 'yellow', 'brown', '#804000', 'red', 'black'], // skinTone
    ['#828fc9', '#75de6e', '#a6a6a6', '#e269de', '#f19d28', '#ff4d4d'],
];

// DesktopView Use Only
export const desktopAttr = {
    left: [
        { name: 'accessory', icon: accessoryIcon, id: 0, colorOptions: -1 }, // 0
        { name: 'body', icon: bodyIcon, id: 1, colorOptions: 5 }, // 1
        { name: 'clothing', icon: clothingIcon, id: 2, colorOptions: 0 }, // 2
        { name: 'eyebrows', icon: eyebrowIcon, id: 3, colorOptions: -1 }, // 3
        { name: 'eyes', icon: eyeIcon, id: 4, colorOptions: -1 }, // 4
        { name: 'faceMask', icon: faceMaskIcon, id: 5, colorOptions: -1 }, // 5
    ],

    right: [
        { name: 'facialHair', icon: facialHairIcon, id: 6, colorOptions: -1 }, // 6
        { name: 'graphic', icon: graphicIcon, id: 7, colorOptions: -1 }, // 7
        { name: 'hair', icon: hairIcon, id: 8, colorOptions: 3 }, // 8
        { name: 'hat', icon: hatIcon, id: 9, colorOptions: 2 }, // 9
        { name: 'lashes', icon: lashesIcon, id: 10, colorOptions: -1 }, // 10
        { name: 'mouth', icon: mouthIcon, id: 11, colorOptions: 4 }, // 11
    ],
};
